import { empty } from 'rxjs';

import * as actionType from '../../store/state/actions';
import { getContainerName } from '../common-helper';
import { getResolvedTargetName } from '../../router/routing-manager';
import { getDirtyDetails } from '../../store/state/epics/util';
import { ActionManagerInstance } from '../../actions/manager';
import type { Action } from '../../store/state/state-manager';

import { executeOpenBulkActionRequest } from './async-request';
import { subscribeBulkActionSubmitEvent, unSubscribeBulkActionSubmitEvent } from './events';

export const processOpenBulkActionRequest = (
  actionInPayload: Action['payload'],
  options: { actionMgrID: string | number }
) => {
  // Todo : Enhance after integrating with actual dxapi
  const { context } = actionInPayload;
  const { actionMgrID } = options;
  actionInPayload.openActionType = actionType.ACTION_OPEN_BULK_ACTION;
  const containerName = getContainerName(actionType.ACTION_OPEN_BULK_ACTION, actionInPayload);
  const target = getResolvedTargetName(containerName, context);
  const { continueExecution } = getDirtyDetails(target);

  // return empty observable in case of user presses on cancel in dirty dialog
  if (!continueExecution) {
    ActionManagerInstance.rejectActionByID(actionMgrID);
    return empty();
  }
  return executeOpenBulkActionRequest(actionInPayload);
};

export const processCallBacks = (actionInPayload: Action['payload']) => {
  const { callbacks } = actionInPayload;
  if (callbacks?.submit) {
    const bulkSubmitCallback = (submitResponse: any) => {
      callbacks.submit(submitResponse);
      unSubscribeBulkActionSubmitEvent('bulkActionSubmit');
    };
    subscribeBulkActionSubmitEvent(bulkSubmitCallback, 'bulkActionSubmit');
  }
};
